export default __webpack_public_path__ + "static/media/logo-capturevi.e612c507.png";